import { useAppSettingsShallowStore } from '@frontend/app-settings-store';
import { useNotificationContext } from '@frontend/notifications';
import { OverrideNotificationRibbon } from '@frontend/phone';
import { usePhoneConfigShallowStore } from '@frontend/phone-config';
import { usePhoneOverrideShallowStoreV2 } from '@frontend/shared';
import { TAB_ID } from '@frontend/tab-management';
import { NotificationsDisabledGlobalBanner } from './notifications-disabled';
import { SoftphoneInAnotherTabRibbon } from './softphone-in-another-tab';

export const RibbonManager = () => {
  const { softphoneRegistrationExists, overrideSoftphoneCheck, activeTab } = useAppSettingsShallowStore(
    'softphoneRegistrationExists',
    'overrideSoftphoneCheck',
    'activeTab'
  );
  const { phoneConfig } = usePhoneConfigShallowStore('phoneConfig');
  /**
   * Softphone Banner Logic:
   * - Show banner when there's softphone activity (conflict or registration)
   * - But hide it when explicitly overriding checks
   */
  const appOpenInAnotherTab = Boolean(activeTab && activeTab !== TAB_ID);
  const hasSoftphoneActivity =
    phoneConfig?.deviceType === 'DEVICE_TYPE_SOFTPHONE' && (appOpenInAnotherTab || softphoneRegistrationExists);
  const showSoftphoneBanner = !overrideSoftphoneCheck && hasSoftphoneActivity;

  const { maxLocationsSelected } = useNotificationContext();
  const { overridesV2 } = usePhoneOverrideShallowStoreV2('overridesV2');
  const phoneOverrides = overridesV2.phoneOverrides;

  const enabledOverrides = phoneOverrides?.filter((override) => override.enabled) || [];

  return (
    <div>
      {maxLocationsSelected && <NotificationsDisabledGlobalBanner />}
      {showSoftphoneBanner && (
        <SoftphoneInAnotherTabRibbon
          // This is finnicky, but the best we can do. If there is a softphone registration, and it's not in a different tab, then we assume it's in another browser.
          isSoftphoneInAnotherBrowser={!appOpenInAnotherTab && softphoneRegistrationExists}
        />
      )}
      {enabledOverrides.length > 0 && <OverrideNotificationRibbon />}
    </div>
  );
};
